import CitySEOHead from "@/components/feature/CitySEOHead";
import CapeCoralHeroSection from "./components/HeroSection";
import CapeCoralStickyNav from "./components/StickyNav";
import CapeCoralProcessingTimeSection from "./components/ProcessingTimeSection";
import CapeCoralServicesSection from "./components/ServicesSection";
import CapeCoralLocalAreaSection from "./components/LocalAreaSection";
import CapeCoralTravelTimingSection from "./components/TravelTimingSection";
import CapeCoralDestinationsSection from "./components/DestinationsSection";
import CapeCoralTestimonialsSection from "./components/TestimonialsSection";
import CapeCoralAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CapeCoralComparisonSection from "./components/ComparisonSection";
import CapeCoralMistakesSection from "./components/MistakesSection";
import CapeCoralHowItWorksSection from "./components/HowItWorksSection";
import CapeCoralFAQSection, { faqs } from "./components/FAQSection";
import CapeCoralHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CapeCoralFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Cape Coral, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Cape Coral, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Lee County travelers, boating enthusiasts, and Southwest Florida residents.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CapeCoralPage() {
  return (
    <>
      <CitySEOHead
        city="Cape Coral"
        state="Florida"
        stateAbbr="FL"
        route="/cities/cape-coral"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Cape Coral, Florida"
        geoPosition="26.5629;-81.9495"
        keywords="expedited passport Cape Coral, emergency passport Cape Coral FL, same day passport Cape Coral, fast passport Florida, passport renewal Cape Coral, Lee County passport, Southwest Florida passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-14"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Cape Coral — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Cape Coral and Lee County travelers."
      />

      <div className="min-h-screen bg-white">
      <CapeCoralHeroSection />
      <CapeCoralStickyNav />
      <CapeCoralProcessingTimeSection />
      <CapeCoralLocalAreaSection />
      <CapeCoralServicesSection />
      <CapeCoralTravelTimingSection />
      <CapeCoralDestinationsSection />
      <CapeCoralTestimonialsSection />
      <CapeCoralAcceptanceFacilitiesSection />
      <CapeCoralComparisonSection />
      <CapeCoralMistakesSection />
      <CapeCoralHowItWorksSection />
      <CapeCoralFAQSection />
      <CapeCoralHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/cape-coral" state="FL" />
      <CapeCoralFinalCTA />
      </div>
    </>
  );
}